import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import TextField from 'Components/ComponentLibrary/Components/Uncategorized/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';
import IconButton from '@material-ui/core/IconButton';


// Icons
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';

const styles = (theme) => ({
  root: {
    '& .MuiTextField-root': {
      fontWeight: theme.typography.fontWeightBold,
    },
  },
});

const PasswordInput = ({
  className,
  classes,
  placeholder,
  onChange,
  label,
  passwordValue,
  inputProps,
  InputProps,
  ...rest
}) => {
  const [showPassword, setShowPassword] = useState(false);
  const toggleShowPassword = () => {
    setShowPassword(!showPassword);
  };

  return (
    <TextField
      className={classNames(classes.root, className)}
      test={'password-input'}
      label={label}
      placeholder={placeholder}
      onChange={onChange}
      value={passwordValue}
      inputProps={{
        type: !showPassword ? 'password' : 'text',
        autoComplete: 'off',
        autoCorrect: 'false',
        spellCheck: 'false',
        ...inputProps,
      }}
        /* eslint-disable-next-line react/jsx-no-duplicate-props */
      InputProps={{
        className: classes.input,
        endAdornment: (
          <InputAdornment position="end">
            <IconButton
              aria-label={'toggle password visibility'}
              onClick={toggleShowPassword}
              onMouseDown={(event) => event.preventDefault()}
              color={'primary'}
            >
              {!showPassword ? <Visibility /> : <VisibilityOff />}
            </IconButton>
          </InputAdornment>
        ),
        ...InputProps,
      }}
      {...rest}
    />
  );
};

PasswordInput.defaultProps = {
  className: '',
  label: 'Password',
  passwordValue: '',
  placeholder: '',
};

PasswordInput.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  placeholder: PropTypes.string,
  label: PropTypes.string,
  passwordValue: PropTypes.string,
};

export default withStyles(styles)(PasswordInput);
